var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"promo"},[_c('div',{staticClass:"grid grid--container"},[_c('h3',{staticClass:"promo__title h2"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"promo__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }